module.exports = __webpack_public_path__ + "img/Realisme_Tanker_i_tida2.dffe0b04.jpg";